import { render, staticRenderFns } from "./AuthorTagsMenu.vue?vue&type=template&id=216213f1"
import script from "./AuthorTagsMenu.vue?vue&type=script&lang=ts"
export * from "./AuthorTagsMenu.vue?vue&type=script&lang=ts"
import style0 from "./AuthorTagsMenu.vue?vue&type=style&index=0&id=216213f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports